module.exports = __webpack_public_path__ + "static/media/arab.8a100ef2.svg";